<template>
  <v-layout>
    <global-header />

    <!-- <global-left /> -->

    <v-main>
      <!-- Provides the application the proper gutter -->
      <v-container fluid class="pa-0">
        <!-- If using vue-router -->
        <slot />
      </v-container>
    </v-main>

    <Teleport :to="teleportTo">
      <v-overlay
        v-model="isLoading"
        class="align-center justify-center"
        :persistent="true"
        :close-on-content-click="false"
      >
        <v-progress-circular color="black" indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <snackbar :show="show"></snackbar>
    </Teleport>

    <global-footer />
  </v-layout>
</template>

<script setup>
import globalHeader from '@/layouts/imports/header'
// import globalLeft from '@/layouts/imports/left'
import globalFooter from '@/layouts/imports/footer'
import snackbar from '@/layouts/imports/snackbar'
import { useTheme } from 'vuetify'

const theme = useTheme()
const pimTheme = useCookie('pim_theme')

const progressbarStore = useProgressbarStore()
const { isLoading, teleportTo } = storeToRefs(progressbarStore)
const { show } = useSnackbarStore()

// data

// method
theme.global.name.value = pimTheme.value || 'light'
</script>

<style scoped></style>
